import Rails from '@rails/ujs'
import '../controllers/medical/alpine/simulation/table'
import '../controllers/medical/alpine/simulation/container'
import './alpine'
import '../controllers/medical'
import '../css/medical.scss'

require.context('../assets/', true, /\.(svg|jpg|png)$/)
Rails.start()
